import { render, staticRenderFns } from "./Feed_Upcoming_Component.vue?vue&type=template&id=06e5bcc0&scoped=true"
import script from "./Feed_Upcoming_Component.vue?vue&type=script&lang=js"
export * from "./Feed_Upcoming_Component.vue?vue&type=script&lang=js"
import style0 from "./Feed_Upcoming_Component.vue?vue&type=style&index=0&id=06e5bcc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e5bcc0",
  null
  
)

export default component.exports